import { BRIEF_CHANNELS, type BriefStatus } from './api';

/**
 * My Briefs' search params: which tab, which channel, and which brief is open.
 *
 * The router owns them (the route's `validateSearch`), so the view follows
 * every navigation — a sidebar link to the bare `/assets/briefs` resets it,
 * where reading the URL once on mount would leave it showing the old tab under
 * the new URL. Defaults are left out of the URL rather than written into it.
 */
export interface BriefsSearch {
  /** Absent means Draft. */
  tab?: Exclude<BriefStatus, 'draft'>;
  /** Absent means every channel. */
  channel?: string;
  /** The brief open in the drawer. A link to it opens it, for the same reader. */
  brief?: string;
}

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Unknown values fall back to the defaults instead of reaching the backend. */
export function parseBriefsSearch(search: Record<string, unknown>): BriefsSearch {
  const tab = search.tab === 'requested' ? 'requested' : undefined;
  const channel = BRIEF_CHANNELS.some((option) => option.value === search.channel)
    ? (search.channel as string)
    : undefined;
  const brief =
    typeof search.brief === 'string' && UUID_PATTERN.test(search.brief) ? search.brief : undefined;
  return { tab, channel, brief };
}
